import React from 'react';
import { Switch, Space, InputNumber } from 'antd';
import { WeeklyStrategy, StrategyPhase } from '../../ProfitScenario/types';
import { calculatePhaseMetrics } from '../../ProfitScenario/calculations';

interface AdsColumnProps {
    week: WeeklyStrategy;
    phase: StrategyPhase;
    index: number;
    landedCost: number;
    fbaFee: number;
    referralRate: number;
    storageFee: number;
    updateWeekStrategy: (phaseId: string, weekIndex: number, updates: Partial<WeeklyStrategy>) => void;
}

export const AdsColumn: React.FC<AdsColumnProps> = ({
    week,
    phase,
    index,
    landedCost,
    fbaFee,
    referralRate,
    storageFee,
    updateWeekStrategy
}) => {
    const metrics = calculatePhaseMetrics({ ...phase, weeks: [week] }, landedCost, fbaFee, referralRate, storageFee);
    const { acos, tacos, adCost: adSpend } = metrics.weeklyMetrics[0];

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Switch
                size="small"
                checked={week.enableAds}
                onChange={(checked) => updateWeekStrategy(phase.id, index, { enableAds: checked })}
                checkedChildren="开"
                unCheckedChildren="关"
            />
            {week.enableAds && (
                <>
                    <Space size={4}>
                        <span style={{ fontSize: 12, color: '#888' }}>CPC:</span>
                        <InputNumber
                            min={0}
                            step={0.01}
                            value={week.cpc}
                            onChange={(val) => updateWeekStrategy(phase.id, index, { cpc: Number(val) })}
                            style={{ width: 70 }}
                            prefix="$"
                            size="small"
                            controls={false}
                        />
                    </Space>
                    <Space size={4}>
                        <span style={{ fontSize: 12, color: '#888' }}>CVR:</span>
                        <InputNumber
                            min={0}
                            max={100}
                            step={0.1}
                            value={week.cvr}
                            onChange={(val) => updateWeekStrategy(phase.id, index, { cvr: Number(val) })}
                            style={{ width: 65 }}
                            suffix="%"
                            size="small"
                            controls={false}
                        />
                    </Space>
                    <Space size={4}>
                        <span style={{ fontSize: 12, color: '#888' }}>占比:</span>
                        <InputNumber
                            min={0}
                            max={100}
                            step={1}
                            value={week.adSalesRatio}
                            onChange={(val) => updateWeekStrategy(phase.id, index, { adSalesRatio: Number(val) })}
                            style={{ width: 65 }}
                            suffix="%"
                            size="small"
                            controls={false}
                        />
                    </Space>

                    <div style={{ width: 1, height: 14, background: '#e8e8e8', margin: '0 4px' }} />

                    <Space size={8} style={{ fontSize: 12, color: '#666', whiteSpace: 'nowrap' }}>
                        <span>ACOS: <b>{acos.toFixed(1)}%</b></span>
                        <span>TACOS: <b>{tacos.toFixed(1)}%</b></span>
                        <span>广告费: <b>${Math.round(adSpend)}</b></span>
                    </Space>
                </>
            )}
        </div>
    );
};
